<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <div id="pnlista" class="card" >
                    <div class="card-header" style="display: flex; justify-content: space-between;" ><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                       
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <button @click.prevent="mtdMostrarEsconderFiltro()" :class="!mostrafiltro ? 'btn primary' : 'btn info'" type="button" >
                                        <span>Filtros</span>
                                        <span><i  :class="!mostrafiltro ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'" ></i></span>
                                    </button>
                                </div>   
                                <div v-show="mostrafiltro" class="row">
                                    <div class="col-sm-4 col-md-2 col-lg-2">
                                        <label for="cbopfiltro">Filtrar:</label>
                                        <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                            <!-- <option value="0">Código</option> -->
                                            <option value="1">Descrição</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-8 col-md-6 col-lg-6">
                                        <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                        <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                                    </div>
                                </div>
                            
                            </div>

                      

                           
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <div style="padding-top: 20px;">
                                    <button type="button" id="btlistar" style="width: 100%;" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="bi bi-search"></i> Listar</button>
                                </div>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstcategorias"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="bi bi-chevron-compact-up"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="bi bi-chevron-down"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                       
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="bgtipo" slot-scope="item">
                                        <button v-if="parseInt(item.row.tipo) === 1" class="btn btn-sm" style="background-color: cadetblue;" > </button>
                                        <button v-else class="btn btn-sm" style="background-color: brown;" > </button>
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="bi bi-pencil"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="bi bi-trash-fill"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstcategorias.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="bi bi-file-earmark"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" >
                    <div class="card-header" style="display: flex; justify-content: space-between;">
                        <span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close btn btn-sm" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vnome" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="cbopfiltro">*Tipo:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="vtipo" >
                                    <option value="0">Despesas</option>
                                    <option value="1">Receitas</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>* Campos obrigatórios</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="bi bi-ban"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /* eslint-disable */
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from 'sweetalert2'
    import util from '../util.js'


    export default {
        name: 'cadcategorias',
        components:{
            VueBootstrap4Table,
            vPagination,
        },
        data: function() {
            return {
                lstcategorias  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud         :  0,
                vid            : '',
                vnome          : '',
                vtipo          : 0, 

                mostrafiltro : false,

                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CATEGORIAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Descrição",
                        name: "nome",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                     {
                        label: 'Tipo',
                        name : 'tipo',
                        slot_name: 'bgtipo',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdMostrarEsconderFiltro(){
                if(this.mostrafiltro){
                    this.mostrafiltro = false
                }else{
                    this.mostrafiltro = true
                }
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(nome) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadcategorias.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregacateg(1);

                    // for (let index = 0; index < 1000000000; index++) {
                    //     console.log("te amo ❤")
                        
                    // }

                }).catch(function (response) {
                    //alert('Erro ao consultar registros');
                });
            },
            mtdcarregacateg(ipagina){
                var vself       = this;
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadcategorias.php');
                retorno.then(function (response) {
                    vself.lstcategorias = response.data; 
                }).catch(function (response) {
                    vself.lstcategorias = [];
                });
            },
            resetarDados() {
               
                this.vid           = '';
                this.vnome         = '';
                this.vtipo         = 0;

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                vself.mtddefault();
            },
            mtdnovo(){
               
                this.itensbc.item2.titulo = 'INCLUSÃO DE CATEGORIAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(1);
                
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcategorias = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim" }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let filtro      = ' and id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadcategorias.php');
                retorno.then(function (response) {
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                  
                });
            },
            mtdalterar(item){
             
                this.itensbc.item2.titulo = 'ALTERAÇÃO CATEGORIAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(2);
                this.mtdlocalizaregistro(item.id);
                
            },
            mtdexcluir(item){
           
                this.itensbc.item2.titulo = 'EXCLUSÃO CATEGORIAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = true;
                this.mtdpreparacrud(3);
                this.mtdlocalizaregistro(item.id);
                
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vnome               = registro.nome;
            },
            mtdregistro(){
                let vself  = this;
                let registrocrud = {
                    'id'                : this.vid,
                    'nome'              : this.vnome,
                    'tipo'              : this.vtipo
                };
                let parametros      = [
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                ];
                let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadcategorias.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregacateg(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif('error', 'Informação!', response.data.substring(4));
                                break;
                            case 'E': default:
                                util.notif('error', 'Informação!', response.data.substring(4));
                                break;
                        }
                    }
                }).catch(function (response) {
                    alert('Erro ao processar o registo. Descrição do erro: '+response.message)
                });
            }
        },
        mounted: function () {
            let vself = this;
            $('#pncadastro').hide();
            $('#pnlista').hide();
            $('#pnlista').show(700);
            vself.mtdexecutapesquisa();
        },
        computed:{
            validou() {
                return this.vnome === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregacateg(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
   
</style>